import React, { useState } from "react";
import styled from "styled-components";
import { Flex, Box, ButtonV1, Text } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";

const BoxForm = styled.div`
  width: 100%;
  max-width: 470px;
  background: #ffffff;
  box-shadow: 0px 4px 11px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  position: absolute;
  top: -5%;
  right: 0px;

  ${mediaQueries.mediaQueries.md} {
    width: 95%;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Form = styled.form`
  padding: 58px 40px 10px;

  .form-orbit {
    & > * {
      width: 100%;

      & > input {
        width: 100%;
        border: none;
        border-bottom: 1px solid #e4e4e4;
        outline: none;
        margin-bottom: 20px;
        height: 60px;
        font-size: 24px;

        ::placeholder {
          color: #d9d9d9;
          opacity: 1;
        }
      }
    }
  }
  .Button-send {
    padding: 80px 0px 71px;
  }

  @media only screen and (max-width: 1132px) {
    .form-orbit {
      & > * {
        & > input {
          font-size: 15px;
        }
      }
      .cus-fz{
        font-size: 8px;
      }
    }
    .Button-send {
      padding: 43px 0px;
    }
  }
  @media only screen and (max-width: 743px){
    display: none;
  }

  ${mediaQueries.mediaQueries.md} {
    padding: 10px;
  }
  @media only screen and (max-width: 576px) {
    .Button-send {
      padding: 40px 0px;
    }
  }
`;

const FormOrbit: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const updateFormData = (event: any) =>
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });

  const { name, email, message } = formData;

  return (
    <BoxForm>
      <Form>
        <Flex
          flexDirection="column"
          alignItems="flex-start"
          className="form-orbit"
        >
          <Box>
            <input
              value={name}
              onChange={(e) => updateFormData(e)}
              placeholder="Name"
              type="text"
              name="name"
              required
            />
          </Box>

          <Box>
            <input
              value={email}
              onChange={(e) => updateFormData(e)}
              placeholder="Email address"
              type="email"
              name="email"
              required
            />
          </Box>

          <Box>
            <input
              value={message}
              onChange={(e) => updateFormData(e)}
              placeholder="Message"
              type="text"
              name="message"
              required
            />
          </Box>
          <Box pt="25px">
            <Flex>
              <input
                type="checkbox"
                id="topping"
                name="topping"
                value="Paneer"
              />
              <Flex>
                <Text className="cus-fz">I agree with</Text>
                <Text className="cus-fz" fontFamily="ManropeBold">
                  Terms & Conditions
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Flex>
        <Box className="Button-send">
          <ButtonV1 width="100%" type="submit">
            Send
          </ButtonV1>
        </Box>
      </Form>
    </BoxForm>
  );
};

export default FormOrbit;
